export const ORDER_DOCUMENT_CONSTANTS = {
  CONTENT: 'content',
  MESSAGE: 'message',
  ABCL: 'abcl',

  NONE: 'None',

  PDF_MIME_TYPE: 'application/pdf',

  DOCUMENT_NOT_GENERATED_WARNING: 'Document is not Generated yet',

  STATUS_COMPLETED: 'COMPLETED',
};
